import React from 'react'
import '../Styles/FxVidrosSection.css'
import Introduction from '../Components/Introduction'
import fxVridrosEsquadrias from '../Assets/logo-esquadrias.webp'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import MarketAnalysis from '../Components/MarketAnalysis'
import GeographicPresence from '../Components/GeographicPresence'

function FxVidroEsquadrias({ id }) {
  return (
    <section id={id}>
      <Introduction
        id="fxvidros-introduction"
        srcLogo={fxVridrosEsquadrias}
        altLogo="Fx Vidros e Esquadrias"
        description="FIXX Vidros e Esquadrias, inscrita sob o CNPJ 54.328.537/0001-04, é uma empresa focada na produção de esquadrias de PVC e alumínio, materiais amplamente utilizados na construção civil devido à durabilidade, eficiência energética e estética. A empresa também atua na distribuição de vidros, fornecendo soluções para diversas demandas no setor de construção e reformas. Esquadrias de PVC e alumínio são reconhecidas pela resistência a intempéries e baixa necessidade de manutenção, o que torna a FIXX Vidros e Esquadrias uma fornecedora estratégica para construtoras e consumidores."
        color="white"
      />

      <Services id="fxvidros-service" colorTitle="white">
        <CardServices
          title="Qualidade dos materiais"
          description="A empresa trabalha com esquadrias de PVC e alumínio, materiais que são reconhecidos por sua durabilidade, resistência a intempéries e baixa manutenção. Esses materiais são ideais para climas tropicais como o brasileiro, onde a exposição constante ao sol, chuva e umidade pode causar danos a outros tipos de esquadrias, como as de madeira."
          backgroundColor="#FF8C00"
          colorTitle="white"
          colorContent="white"
          height="300px"
        />
        <CardServices
          title="Eficiência energética"
          description="As esquadrias de PVC e alumínio oferecem um excelente isolamento térmico, reduzindo a necessidade de climatização interna. Isso contribui para a eficiência energética das edificações e ajuda a reduzir os custos de energia, uma demanda crescente em projetos modernos de construção sustentável."
          backgroundColor="#FF8C00"
          colorTitle="white"
          colorContent="white"
          height="300px"
        />
        <CardServices
          title="Variedade de vidros"
          description="A empresa não apenas produz esquadrias, mas também atua na distribuição de vidros, o que a torna uma fornecedora completa de soluções para construção. A distribuição de vidros de alta performance, como os laminados e temperados, garante segurança e estética para uma ampla gama de projetos arquitetônicos."
          backgroundColor="#FF8C00"
          colorTitle="white"
          colorContent="white"
          height="300px"
        />
        <CardServices
          title="Personalização e atendimento a projetos especiais"
          description="A FIXX Vidros e Esquadrias oferece soluções personalizadas para projetos específicos, seja em grandes edificações comerciais ou residências de alto padrão. A possibilidade de adaptação de suas esquadrias e vidros de acordo com as necessidades estéticas e funcionais de cada cliente é um grande diferencial competitivo."
          backgroundColor="#FF8C00"
          colorTitle="white"
          colorContent="white"
          height="300px"
        />
        <CardServices
          title="Baixa manutenção"
          description="As esquadrias de PVC e alumínio exigem menos manutenção em comparação com outros materiais, o que é um grande atrativo para construtoras e consumidores que buscam soluções duráveis e de longo prazo. O PVC, por exemplo, não enferruja, não apodrece e tem uma vida útil longa, mesmo em ambientes agressivos como regiões litorâneas."
          backgroundColor="#FF8C00"
          colorTitle="white"
          colorContent="white"
          height="300px"
        />
        <CardServices
          title="Sustentabilidade"
          description="O PVC e o alumínio são materiais recicláveis, e as práticas de sustentabilidade na construção civil são cada vez mais valorizadas. A FIXX Vidros e Esquadrias está alinhada com essa tendência, o que pode ser um fator decisivo para consumidores e construtoras que priorizam o impacto ambiental de seus projetos."
          backgroundColor="#FF8C00"
          colorTitle="white"
          colorContent="white"
          height="300px"
        />
        <CardServices
          title="Capacidade de entrega"
          description="A empresa tem uma boa capacidade de produção e logística para atender tanto a pequenos quanto a grandes projetos. Sua base sólida e capacidade de fornecer em escala tornam a FIXX Vidros e Esquadrias um parceiro estratégico para grandes construtoras."
          backgroundColor="#FF8C00"
          colorTitle="white"
          colorContent="white"
          height="300px"
        />
      </Services>
      <MarketAnalysis
        description={
          <>
            O setor de esquadrias e vidros está fortemente ligado à construção
            civil, que é um dos motores da economia brasileira. Com a crescente
            demanda por construções sustentáveis, o mercado de esquadrias de PVC
            e alumínio tem ganhado destaque. Esses materiais são preferidos por
            sua durabilidade, eficiência energética e apelo estético,
            características que são cada vez mais procuradas por construtoras e
            consumidores que buscam soluções modernas e de baixo custo de
            manutenção.
            <br />
            <br />
            <span>
              Esquadrias de PVC e Alumínio são reconhecidas por sua resistência
              a intempéries, isolamento acústico e térmico superior em
              comparação com outros materiais, como madeira ou aço.
            </span>{' '}
            No Brasil, a demanda por construções que aliam sustentabilidade com
            eficiência energética tem aumentado, o que coloca a FIXX Vidros e
            Esquadrias em uma posição favorável.
            <br />
            <br />O mercado de vidros também está em expansão, impulsionado pela{' '}
            <span>
              maior utilização de vidros de alta performance, como os laminados
              e temperados, que agregam segurança e eficiência energética às
              construções.
            </span>{' '}
            A versatilidade dos vidros para fachadas, divisórias e janelas
            reforça a relevância da FIXX Vidros e Esquadrias nesse segmento.
            <br />
            <br />A empresa está bem posicionada para atender à demanda
            crescente, principalmente em projetos residenciais e comerciais de
            médio a grande porte.
          </>
        }
      />

      <GeographicPresence
        description={
          <>
            A FIXX Vidros e Esquadrias tem sua sede localizada na Avenida Heitor
            Alencar Furtado, 7671, Jardim Santos Dumont, Paranavaí-PR, uma{' '}
            <span>localização estratégica no estado do Paraná,</span> uma região
            que tem visto crescimento no setor de construção civil. Paranavaí
            está inserida em uma área que permite fácil acesso a outros estados
            do Sul e Centro-Oeste, facilitando a distribuição de seus produtos.
            <br />
            <br />A empresa tem uma atuação local forte, mas seu modelo de
            negócio pode facilmente escalar para atender construtoras e projetos
            em outras regiões do Brasil. Com uma localização próxima a
            importantes centros urbanos e rodovias, a FIXX Vidros e Esquadrias
            tem a logística a seu favor para atender a uma clientela
            diversificada em várias regiões do país, especialmente com o
            crescimento de centros urbanos que demandam soluções de alta
            qualidade para vidros e esquadrias.
          </>
        }
      />
    </section>
  )
}

export default FxVidroEsquadrias
